@let isLoading = loadingService.isLoading$(this) | async;

<icz-wizard [showSubmitBar]="false" [alwaysEnableAllSteps]="!isNew" [waiting]="isLoading">
  <ng-template
    [iczWizardStep]="SharedFolderWizardStep.SHARED_FOLDER_SPECIFICATION"
    label="Pojmenování složky"
  >
    <div class="p-16" [formGroup]="form">
      <div class="row-16">
        <icz-form-field formControlName="name" label="Název složky" class="grow"></icz-form-field>
        <icz-shared-folder-selector
          [view]="SharedFolderSelectorView.MANAGEABLE_FOLDERS"
          [form]="form" controlName="parentId" class="grow"
          label="Nadřazená složka" [disabledSubtreeRootId]="sharedFolder?.id"
        ></icz-shared-folder-selector>
      </div>
      @if (!isNew) {
        <div class="row-16">
          <icz-date-picker [fieldDisabled]="true" label="Založeno" [value]="sharedFolder?.auditInfo?.createdAt" class="grow"></icz-date-picker>
          <icz-date-picker [fieldDisabled]="true" label="Poslední úprava" [value]="sharedFolder?.auditInfo?.modifiedAt" class="grow"></icz-date-picker>
        </div>
      }
      @if (showAutoFillOptions) {
        <icz-checkbox label="Automaticky plněná sdílená složka" formControlName="autoFilled"></icz-checkbox>
        @if (form.get('autoFilled')!.value) {
          @if (humanReadableFilter) {
            <div class="col mt-4">
              <span class="icz-body-1">{{ 'Kritéria výběru objektů:' | translate }}</span>
              <span class="icz-body-1" [innerHTML]="humanReadableFilter"></span>
            </div>
          }
          <icz-button
            class="inline-block mt-8"
            label="Vybrat kritéria výběru objektů" (onAction)="selectObjects()"
          ></icz-button>
        }
      }
    </div>
  </ng-template>
  <ng-template
    [iczWizardStep]="SharedFolderWizardStep.SHARED_FOLDER_PERMISSIONS"
    label="Oprávnění ke složce"
  >
    @if (isNew) {
      <icz-members-with-permissions-table
        [form]="form"
        [permissionOptions]="sharedFolderPermissionOptions"
        [disableSelfPermissionAssignment]="true"
        [updateModeMemberPermissions]="[]"
        permissionTooltipTranslationPrefix="SHARED_FOLDER"
      ></icz-members-with-permissions-table>
    }
    @else {
      <icz-permission-settings-table
        class="grow h-full"
        tableTitle="Oprávnění ke sdílené složce"
        [disableOrgUnitPermissions]="true"
        [entityId]="sharedFolder!.id"
        [entityType]="AuthorizedEntityType.SHARED_FOLDER"
      ></icz-permission-settings-table>
    }
  </ng-template>
  <ng-template
    [iczWizardStep]="SharedFolderWizardStep.SHARED_FOLDER_HISTORY"
    [stepHidden]="isNew"
    label="Historie změn"
  >
    <icz-transactions
      [type]="TransactionHistoryType.ENTITY"
      [identifier]="sharedFolder!.uid!.identifier"
      [idSource]="sharedFolder!.uid!.idSource"
    ></icz-transactions>
  </ng-template>
</icz-wizard>

<icz-form-buttons>
  <ng-container leftButtons>
    @if (isNew && isAtSharedFolderSpecificationStep) {
      <icz-button iczFormSubmit
                  [disabled]="isLoading"
                  (onAction)="goToPermissionsStep()"
                  primary label="K nastavení oprávnění"
      ></icz-button>
    }
    @else {
      <icz-button iczFormSubmit
                  [disabled]="isLoading"
                  (onAction)="submit()"
                  primary [label]="isNew ? 'Založit' : 'Uložit změny'"
      ></icz-button>
    }
  </ng-container>
  <icz-button rightButtons
              [disabled]="isLoading"
              (onAction)="cancel()" label="Storno"
  ></icz-button>
</icz-form-buttons>
